// extracted by mini-css-extract-plugin
export var clock = "TopBar-module--clock--3449b";
export var date = "TopBar-module--date--32bec";
export var logo = "TopBar-module--logo--5a0c6";
export var logoSvg = "TopBar-module--logoSvg--ce33a";
export var longDate = "TopBar-module--longDate--7e6ce";
export var outer = "TopBar-module--outer--b8233";
export var root = "TopBar-module--root--4fe61";
export var shortDate = "TopBar-module--shortDate--b9edd";